import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {DashboardDoctorsPsychologistsPieChart} from '../dashboard-doctors-psychologists-pie-chart/DashboardDoctorsPsychologistsPieChart'
import {useGetDashboardConsultants} from '../../query/useGetDashboardConsultants'
import {PieChartLegend, PieChartLegendData} from '../pie-chart-legend/PieChartLegend'
import {useMemo} from 'react'
import {useTheme} from 'styled-components'
import {DashboardDoctorsPsychologistsCardSkeleton} from './DashboardDoctorsPsychologistsCardSkeleton'

export const DashboardDoctorsPsychologistsCard = () => {
    const {t} = useTranslation()
    const {data, isLoading} = useGetDashboardConsultants({
        fields: ['operativeConsultants']
    })

    const totalDoctors = useMemo(() => {
        return (
            (data?.operativeConsultants?.doctors.flat_rate ?? 0) + (data?.operativeConsultants?.doctors.consultant ?? 0)
        )
    }, [data])

    const {palette} = useTheme()

    const legendData: PieChartLegendData[] = useMemo(() => {
        return [
            {
                name: t('dashboard:doctors_psychologists_flat_rate'),
                value: data?.operativeConsultants?.doctors.flat_rate,
                color: palette.primary[400]
            },
            {
                name: t('dashboard:doctors_psychologists_consultant'),
                value: data?.operativeConsultants?.doctors.consultant,
                color: palette.primary[200]
            }
        ]
    }, [data])

    if (isLoading) {
        return <DashboardDoctorsPsychologistsCardSkeleton />
    }

    return (
        <DashboardCard title={t('dashboard:doctors_psychologists')}>
            <Grid columns={2} gap={2}>
                <Flexbox direction="column" gap={4}>
                    <Text palette="neutral" shade="900" size="displaySm" weight={700}>
                        {totalDoctors}
                    </Text>

                    <PieChartLegend data={legendData} size="sm" />
                </Flexbox>
                <DashboardDoctorsPsychologistsPieChart />
            </Grid>
        </DashboardCard>
    )
}
